module.exports = __webpack_public_path__ + "static/media/patreon.e1abd3fd.png";